import * as yup from "yup";

export interface ResetPasswordFormValues {
    passwordBaru: string;
    passwordBaruUlang: string;
}

export const resetPasswordSchema = yup
    .object({
        passwordBaru: yup
            .string()
            .required("Kolom wajib diisi")
            .min(8, "Kata sandi minimal 8 karakter"),
        passwordBaruUlang: yup
            .string()
            .required("Kolom wajib diisi")
            .oneOf([yup.ref("passwordBaru")], "Kata sandi baru tidak sama"),
    })
    .required();
